import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import NonNachaFileImportPage, { getDefaultData, getDefaultUI } from "components/pages/NonNachaFileImportPage";
import Classes, { Company } from "model";

/**
 * @name CaptureFileImportFileSelected
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH - ImportFile (Non-NACHA)" (abi22).
 */
export default function CaptureFileImportFileSelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const selectedCompany = Company.initAll().filter(item => item.id === "0")[0];
    const selectedtransactionType = getDefaultData().transactionsType.filter(item => item.id === "2")[0];

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "selectedCompany" ], selectedCompany)
    .update([ "selectedtransactionType" ], selectedtransactionType.value)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "isCompanySelected" ], true)
    .update([ "isFileChosen" ], true)
    .submit();

    return <NonNachaFileImportPage data={ data } ui={ ui } />;
}